// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"vX-z","sponsoredTooltipWrapper":"wX-z","sponsoredTooltip":"xX-z","newCard":"yX-z"};